import React from 'react';
import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { BILL_AGE_COLORS, billAge, BillAgeType } from './billAge';

type BillAgeTagProps = {
  date: string;
  accountToday: string;
};

export const BillAgeTag = ({ date, accountToday }: BillAgeTagProps) => {
  const { t } = useTranslation();
  const age = billAge(date, accountToday);
  const colors = BILL_AGE_COLORS[age.type];
  const label = {
    [BillAgeType.TODAY]: t('open_bills.age_today'),
    [BillAgeType.YESTERDAY]: t('open_bills.age_yesterday'),
    [BillAgeType.DAYS_AGO]: t('open_bills.age_days_ago', { count: age.days }),
  }[age.type];

  return (
    <Typography
      component="span"
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        alignSelf: 'flex-start',
        height: 22,
        paddingInline: 1,
        borderRadius: '4px',
        fontSize: 13,
        fontWeight: 500,
        whiteSpace: 'nowrap',
        backgroundColor: colors.fill,
        color: colors.ink,
      }}>
      {label}
    </Typography>
  );
};
